<template>
  <div class="my-group-buy-card">
    <div class="title">
      <div class="title-left">{{ titleText }}</div>
      <div class="title-right">
        <template v-if="cardDetail.groupInfoRespVO.status === 2 && cardDetail.status === 2">
          还差<span>{{ groupPersonNum() }}</span>人拼团成功
        </template>
        <template v-else>
          {{titlePayText}}
        </template>
      </div>
    </div>
    <div class="content text-overflow">
      {{ cardDetail.productName }}
    </div>
    <div class="footer">
      <div class="footer-time">
        <template v-if="endTime">
          <template v-if="cardDetail.status === 1">
            支付倒计时:
          </template>
          <template v-else>
            距结束倒计时:
          </template>
          <span class="timer-div"><CommonTimer type="groupBuy" :endTime="endTime" @timerEnd="timerEnd"/></span>
        </template>
      </div>
      <div class="btn-div" :class="{'btn-empty': !btnShow}">
        <template v-if="btnShow">
          <div class="footer-btn no-bg" v-if="cardDetail.groupInfoRespVO.status === 3" @click="goCourseDetail">查看课程</div>
          <div class="footer-btn" @click="goPage">{{ btnStatus() }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import CommonTimer from '@/components/commonComponents/CommonTimer.vue';
// import { reqGetGroupDetail } from '@/api/courseDetail/groupBuy/groupBuy';

export default {
  components: {
    CommonTimer,
  },
  props: {
    cardDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      groupOrderStatus: {
        1: '待支付',
        2: '已支付',
        3: '已取消',
        4: '已关闭',
        5: '已退款',
      },
      groupStatus: {
        1: '待开团',
        2: '拼团中',
        3: '拼团成功',
        4: '拼团失败',
        5: '拼团失败',
      },
      titleText: '',
      titlePayText: '',
      endTime: '',
      btnType: '',
      countDownTimerEnd: false,
      btnShow: true,
    };
  },
  computed: {
    btnStatus() {
      // eslint-disable-next-line func-names
      return function () {
        let text = '';
        const { groupInfoRespVO } = this.cardDetail;
        if (this.cardDetail.status === 1) {
          text = '待支付';
          this.btnType = 'pay';
        } else if (this.cardDetail.status === 4) {
          // 拼团关闭
          text = '查看详情';
          this.btnType = 'groupDetail';
        } else if (groupInfoRespVO.status === 2) {
          // 拼团中
          text = '邀请好友';
          this.btnType = 'groupDetail';
        } else if (groupInfoRespVO.status === 3) {
          // 拼团成功
          text = '拼团详情';
          this.btnType = 'groupDetail';
        } else if (groupInfoRespVO.status === 4) {
          text = '查看详情';
          this.btnType = 'groupDetail';
        }
        return text;
      };
    },
  },
  mounted() {
    this.init();
    // this.timerEnd()
  },
  methods: {
    async timerEnd() {
      this.countDownTimerEnd = true;
      /* const res = await reqGetGroupDetail({
        groupId: this.cardDetail.groupId,
      });
      if (res.code === 0) {
        this.$set(this.cardDetail, 'status', 4);
        // this.$set(this.cardDetail, 'createTime', res.data.createTime);
        this.$set(this.cardDetail, 'groupInfoRespVO', res.data.groupOrderRespVOS[0]);
      }
      console.log(this.cardDetail);
      this.init(); */
    },
    init() {
      const { groupInfoRespVO } = this.cardDetail;
      if (groupInfoRespVO.status === 2 && this.cardDetail.status === 1) {
        // 拼团中和待支付时; 为参团人，此时不展示状态
        this.titleText = '';
      } else if (this.cardDetail.status === 4 || this.cardDetail.status === 3) {
        // 支付超时，不展示团状态，仅展示支付关闭
        this.titleText = '';
        this.btnShow = false;
      } else {
        this.titleText = this.groupStatus[groupInfoRespVO.status];
      }

      const titlePayTextArr = [3, 4, 5];
      // 拼团中与拼团成功时，不显示支付状态
      if (titlePayTextArr.indexOf(this.cardDetail.status) > -1 && groupInfoRespVO.status !== 1 && groupInfoRespVO.status !== 2 && groupInfoRespVO.status !== 3) {
        this.titlePayText = this.groupOrderStatus[this.cardDetail.status];
      }

      if (this.cardDetail.status === 1) {
        this.endTime = moment(this.cardDetail.createTime).add(30, 'm').format('X');
      } else if (groupInfoRespVO.status === 2 && this.cardDetail.status === 2) {
        this.endTime = moment(groupInfoRespVO.endTime).format('X');
      }
    },
    groupPersonNum() {
      const { groupInfoRespVO } = this.cardDetail;
      const num = groupInfoRespVO.groupNumber - groupInfoRespVO.joinNumber;
      return num > 0 ? num : '';
    },
    goPage() {
      if (this.btnType === 'pay') {
        if (this.countDownTimerEnd) {
          this.$toast('待支付时间超时，请刷新页面！');
          return;
        }
        if (this.$root.$data.isApp) {
          const param = {
            orderNo: this.cardDetail.groupOrderNo,
            type: 2,
            groupId: this.cardDetail.groupId,
          };
          this.$sendToApp('payCenter', param, false);
        } else {
          this.$router.push({
            path: '/cashier',
            query: {
              orderNo: this.cardDetail.groupOrderNo,
              source: 2,
              groupId: this.cardDetail.groupId,
            },
          });
        }
      } else if (this.btnType === 'groupDetail') {
        this.$router.push({
          path: '/groupProgress',
          query: {
            groupId: this.cardDetail.groupId,
          },
        });
      }
    },
    goCourseDetail() {
      // 跳转我的课程
      if (this.$root.$data.isApp) {
        this.$sendToApp('goLearnCenterPage', false);
      } else {
        this.$router.push({
          path: '/personalCenter/mycourseList',
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.my-group-buy-card {
  margin-top: 22px;
  padding: 29px;
  background: white;
  border-radius: 14px;

  .title {
    display: flex;
    justify-content: space-between;
    color: #333;
    font-weight: 500;
    font-size: 33px;
    line-height: 45px;

    .title-left {
      color: #FF6C02;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
    }

    .title-right {
      color: #787878;
      font-weight: 400;
      font-size: 25px;
      line-height: 36px;

      span {
        color: #FF6C02;
      }
    }
  }

  .content {
    margin-top: 20px;
    color: #333;
    font-weight: 500;
    font-size: 25px;
    line-height: 72px;
    border-bottom: 2px solid #f5f5f5;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 22px 0 0;

    .footer-time {
      display: flex;
      color: #787878;
      font-weight: 400;
      font-size: 25px;
      line-height: 36px;

      .timer-div {
        display: flex;
        align-items: center;
        color: $theme_color;
      }
    }

    .btn-div {
      display: flex;
    }

    .btn-empty{
      height: 33px;
    }

    .footer-btn {
      display: flex;
      align-items: center;
      align-self: flex-end;
      justify-content: center;
      min-width: 132px;
      height: 43px;
      padding: 0 14px;
      color: #fff;
      font-weight: 500;
      font-size: 25px;
      background: $theme_color;
      border-radius: 34px;
    }

    .no-bg {
      margin-right: 25px;
      color: $theme_color;
      background: white;
      border: 2px solid $theme_color;
    }
  }
}
</style>
